module.exports = __webpack_public_path__ + "media/assets/svg/logos/unox_logo-16150aa13984026ba284f7e1b134c856.svg";